import React from "react";

import "./ScrollDown.css";

const ScrollDown = ({ scrollDown }) => {
  return <div className="scroll" onClick={scrollDown}></div>;
};

export default ScrollDown;
